let sessionToken: string | null = null;

export async function bootstrap() {
  if (sessionToken) return sessionToken;

  const response = await fetch("http://localhost:4446/api/bootstrap", {
    method: "GET"
  });

  if (!response.ok) {
    throw new Error("Bootstrap failed");
  }

  const data = await response.json();
  sessionToken = data.sessionToken;

  return sessionToken;
}

export function getSessionToken() {
  return sessionToken;
}
